import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { Link } from 'react-router-dom'
import { Trans } from 'react-i18next'

import i18n from '@flatsy/utils/translations'

import { useGtmContext } from '../Gtm'

const useStyle = makeStyles((theme) => ({
  container: {
    padding: 16,
    backgroundColor: '#f5f6fa',
    borderRadius: 8,

    display: 'flex',
    alignItems: 'center',
    gap: 16,

    [theme.breakpoints.down('sm')]: {
      padding: 12,
      flexDirection: 'column',
    },
  },
  btContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  mainText: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  desktopText: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

type ConsentProps = {
  textKey?: string
  refuseKey?: string
  acceptKey?: string
}

const Consent: React.FC<ConsentProps> = ({
  textKey = 'consent_main_text',
  refuseKey = 'refuse',
  acceptKey = 'accept',
}) => {
  const classes = useStyle()

  const { consentIsSet, applyConsent } = useGtmContext()

  if (consentIsSet) {
    return null
  }

  const handleRefuse = () => {
    applyConsent('reject_all')
  }

  const handleAccept = () => {
    applyConsent('accept_all')
  }

  return (
    <div className={classes.container}>
      <div className={classes.mainText}>
        <Trans
          i18nKey={textKey}
          components={{
            desktop: <span className={classes.desktopText} />,
            privacy: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
              <a
                href="https://www.flatsy.fr/politique-de-vie-privee/"
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </div>
      <div className={classes.btContainer}>
        <Button variant="contained" color="primary" disableElevation onClick={handleRefuse}>
          {i18n.t(refuseKey)}
        </Button>
        <Button variant="contained" color="primary" disableElevation onClick={handleAccept}>
          {i18n.t(acceptKey)}
        </Button>
      </div>
    </div>
  )
}

export default Consent
